import request from "@/utils/request";
// 商户列表
export function storeList(params) {
    return request({
        url: "delivery/store/index",
        method: "get",
        params,
    });
}
// 添加商户
export function addStore(data) {
    return request({
        url: "delivery/store/save",
        method: "post",
        data,
    });
}
// 查看商户信息
export function getStoreInfo(params) {
    return request({
        url: "delivery/store/save",
        method: "get",
        params,
    });
}
// 余额充值
export function recharge(data) {
    return request({
        url: "delivery/store/recharge",
        method: "post",
        data,
    });
}
//获取城市
export function getCity(params) {
    return request({
        url: "delivery/config/get-city",
        method: "get",
        params,
    });
}
//删除delete
export function deleteStore(data) {
    return request({
        url: "delivery/store/delete",
        method: "post",
        data,
    });
}
//定位
export function getLocation(params) {
    return request({
        url: "delivery/store/get-location",
        method: "get",
        params,
    });
}
//计价设置
export function postConfig(data) {
    return request({
        url: "delivery/config/config",
        method: "post",
        data,
    });
}
//储值列表
export function valueList(params) {
    return request({
        url: "delivery/store/value-list",
        method: "get",
        params,
    });
}
//计价规则
export function priceRule(data) {
    return request({
        url: "delivery/store/price-set",
        method: "post",
        data,
    });
}
//计价规则
export function priceRuleInfo(params) {
    return request({
        url: "delivery/store/price-set",
        method: "get",
        params,
    });
}